import { Environment } from '@fitscovery/common/environments';

export const environment: Environment = {
  production: false,
  fitscoveryApps: {
    accountUrl: 'https://dev-account.fitscovery.com',
    adminUrl: 'https://dev-admin.fitscovery.com',
    fitscoveryUrl: 'https://dev.fitscovery.com',
    myDiscoveryUrl: 'https://dev-my.fitscovery.com',
    backofficeUrl: '',
    onboardingUrl: 'https://dev-onboarding-fitscovery.web.app/'
  },
  apiKeys: {
    appInsights: '',
    googleMaps: 'AIzaSyDQUPOClCBqAJUmBd3-FkcG6tZJaHL_SoI',
    recaptchaKey: '6Lc_78YUAAAAAPJNHe4B-ZyvRY_ZWI76n0cW6VR9'
  },
  azureFunctionsApi: {
    auth: 'https://dev-api-auth-fitscovery.azurewebsites.net/api',
    events: 'https://dev-api-events-fitscovery.azurewebsites.net/api',
    partners: 'https://dev-api-partners-fitscovery.azurewebsites.net/api',
    memberships: 'https://dev-functions-memberships-fitscovery.azurewebsites.net/api',
    users: 'https://dev-api-users-fitscovery.azurewebsites.net/api',
    workouts: 'https://dev-api-workouts-fitscovery.azurewebsites.net/api',
    products: 'https://dev-functions-products-fitscovery.azurewebsites.net/api',
    payments: 'https://dev-functions-payments-fitscovery.azurewebsites.net/api',
    posts: 'https://dev-functions-posts-fitscovery.azurewebsites.net/api',
    bookings: 'https://dev-functions-bookings-fitscovery.azurewebsites.net/api'
  },
  azureFunctions: {
    images: {
      uploadUrl: 'https://devfitscoverypartnerimg1.blob.core.windows.net/for-image-compression',
      api: 'http://localhost:7071/api',
      functionsKey: 'zD47av/RJCeA7TxiLQyAN/aaRiUWrrBw3DL31XUI7jQE//7fDCFvVA=='
    }
  },
  cloudFunctionApi: 'https://asia-northeast1-mymvmnt-dev.cloudfunctions.net/api',
  paymentsApi: {
    paymongo: 'https://api.paymongo.com/v1',
    paymongoKey: 'pk_test_AqVzUhLdTX5iGV62EX79HofY'
  },
  xendItApi: {
    url: 'https://dev-api-payments-sea.fitscovery.com/api/v1',
    key: ''
  },
  firebase: {
    apiKey: 'AIzaSyAPSNihWzdt5mU8v7xibCQbo3dDICX4TZw',
    authDomain: 'mymvmnt-dev.firebaseapp.com',
    databaseURL: 'https://mymvmnt-dev.firebaseio.com',
    projectId: 'mymvmnt-dev',
    storageBucket: 'mymvmnt-dev.appspot.com',
    messagingSenderId: '498081428868',
    appId: '',
    measurementId: ''
  },
  facebook: {
    appId: '457939397980694',
    clientToken: '7690929d4a88a7a5ceef63425698da88'
  },
  version: '0.0.0',
  nodeApi: {
    users: ''
  }
};
